import React from 'react';
import App from '../../../App/App';
// Override some styles
import './App.scss';

const AppOFC = (props) => (
  <App {...props} containerExtraClassName="ofc-serenity-eu" />
);
export default AppOFC;
